import { createBuilderModule } from '../../../builder';
import { TIME_INPUT } from '../utils';
import { AgendaHero } from './AgendaHero';

export default createBuilderModule(AgendaHero, {
  name: 'AgendaHero',
  inputs: [
    { name: 'imageUrl', type: 'cloudinaryImage', required: true },
    { name: 'imageAltText', type: 'string', required: true },
    { name: 'logoUrl', type: 'cloudinaryImage', required: true },
    { name: 'logoAltText', type: 'string', required: true },
    { name: 'event', type: 'string' },
    { name: 'showHeadingContainer', type: 'boolean' },
    { name: 'heading', type: 'string' },
    { name: 'showToggleSwitch', type: 'boolean' },
    { ...TIME_INPUT, name: 'startTime' },
  ],
});
